import axios from 'axios';
import axiosInstance from '../axios';
import { rejectError } from '../helper';
import router from '../../router';
import { STORE_TYPES } from './types';

const transformRequest = (jsonData = {}) => Object.entries(jsonData)
  .map(x => `${encodeURIComponent(x[0])}=${encodeURIComponent(x[1])}`)
  .join('&');

export default {
  state: {
    idToken: null,
    username: null,
    user: null,
    project: '',
  },
  mutations: {
    setToken(state, token) {
      state.idToken = token;
    },
    setUsername(state, username) {
      state.username = username;
    },
    storeUser(state, user) {
      state.user = user;
    },
    clearAuthData(state) {
      state.idToken = null;
      state.username = null;
      state.user = null;
    },
    setProject(state, project) {
      state.project = project;
    },
  },
  getters: {
    user(state) {
      return state.user;
    },
    isAuthenticated(state) {
      return state.idToken !== null;
    },
    getUsername(state) {
      return state.username;
    },
    projectCode(state) {
      return state.project;
    },
    projectTitle(state) {
      return STORE_TYPES.PROJECT_CODE_TO_TITLE[state.project] || '';
    },
  },
  actions: {
    fetchProject({ commit }) {
      const projectCode = localStorage.getItem('project');
      if (projectCode) {
        commit('setProject', projectCode);
      }
    },
    changeProject({ commit }, code) {
      localStorage.setItem('project', code);
      commit('setProject', code);
    },
    checkEmail({ commit }, email) {
      const data = {
        Username: email,
      };
      return axios.post('/api/3/registrations/check', data)
        .then((res) => {
          return res.data;
        })
        .catch((error) => {
          return rejectError(error);
        });
    },
    signUp({ commit, dispatch }, authData) {
      return axios.post('/api/3/registrations', {
        user: {
          username: authData.username,
          password: authData.password,
          name: authData.name,
          company: authData.company,
        },
        // beta_code: '1234',
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Tenant': 'qa',
        },
      })
        .then((res) => {
          return res.data;
        })
        .catch(error => {
          return rejectError(error);
        });
    },
    setLogoutTimer({ commit }, expirationTime) {
      setTimeout(() => {
        commit('clearAuthData');
      }, expirationTime * 1000);
    },
    login({ commit, dispatch }, authData) {
      const data = {
        grant_type: 'password',
        username: authData.username,
        password: authData.password,
      };
      return axios.post('/api/3/authorize', transformRequest(data), {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      })
        .then(res => {
          localStorage.setItem('token', res.data.data);
          return commit('setToken', res.data.data);
          /* const now = new Date();
          const expirationDate = new Date(now.getTime() + res.data.expiresIn * 1000);
          localStorage.setItem('expirationDate', expirationDate);
          dispatch('setLogoutTimer', res.data.expiresIn); */
        })
        .catch((error) => {
          return rejectError(error);
        });
    },
    checkToken({ commit, dispatch }, token) {
      const params = {};
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      return axios.get('/api/3/users/me', {
        params,
        headers,
      })
        .then(() => {
          localStorage.setItem('token', token);
          commit('setToken', token);
          return dispatch('fetchUser');
        })
        .catch(error => rejectError(error));
    },
    finish({ commit, dispatch }, code) {
      const data = {
        ack: code,
      };
      return axios.post('/api/3/registrations/finish', data)
        .then((res) => {})
        .catch(error => rejectError(error));
    },
    passwordReset({ commit }, email) {
      const data = {
        Username: email,
      };
      return axios.post('/api/3/password-resets', data)
        .then(res => res.data)
        .catch(error => rejectError(error));
    },
    passwordResetFinish({ commit }, formData) {
      const data = {
        ack: formData.ack,
        password: formData.password,
      };
      return axios.post('/api/3/password-resets/finish', data)
        .then((res) => {
          return res.data;
        })
        .catch(error => rejectError(error));
    },
    tryAutoLogin({ commit, state, dispatch }) {
      const token = localStorage.getItem('token');
      if (!token) {
        return;
      }
      commit('setToken', token);
      /* const expirationDate = localStorage.getItem('expirationDate');
       const now = new Date();
       if (now >= expirationDate) {
         return;
       } */
      const username = localStorage.getItem('username');
      if (!username) {
        return;
      }
      commit('setUsername', username);
      if (!state.user) {
        return dispatch('fetchUser');
      }
    },
    logout({ commit }) {
      commit('clearAuthData');
      localStorage.removeItem('expirationDate');
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      router.replace('/signin');
    },
    updateUser({ commit, state }, userData) {
      if (!state.idToken) {
        return;
      }
      return axiosInstance({
        method: 'PATCH',
        url: '/api/3/users/me',
        data: {
          name: userData.name,
          company: userData.company,
        },
      })
        .then(res => res)
        .catch(error => rejectError(error));
    },
    changeMyPassword({ commit }, formData) {
      const data = {
        old_password: formData.oldPassword,
        new_password: formData.newPassword,
      };
      return axiosInstance.post('/api/3/users/me/change-password', data)
        .then((res) => {
          return res.data;
        })
        .catch((error) => rejectError(error));
    },
    fetchUser({ commit, state }) {
      if (!state.idToken) {
        return;
      }
      axiosInstance.get('/api/3/users/me?$expand=*')
        .then((res) => {
          const user = res.data.data;
          commit('storeUser', user);
          commit('setUsername', user.username);
          localStorage.setItem('username', user.username);
        })
        .catch(error => rejectError(error));
    },
  },
};
